/*
  Bath & Spa Parts Online - Troubleshooting Search
  Asset: bspo-troubleshooting-search.js

  Expands natural-language troubleshooting searches and ranks matching
  resources already rendered on page.troubleshooting.liquid.
*/
(function () {
  'use strict';

  var INTENTS = [
  {
    "id": "after-drain-refill",
    "phrases": [
      "problems after draining",
      "problems after refill",
      "problems after refilling",
      "hot tub not working after refill",
      "spa not working after refill",
      "hot tub wont work after draining",
      "hot tub won't work after draining",
      "spa pump wont prime after draining",
      "spa pump won't prime after draining",
      "pump wont prime after refill",
      "pump won't prime after refill",
      "air lock after refill",
      "air lock after draining",
      "flo error after refill",
      "flow error after refill",
      "dry error after refill",
      "dr error after refill",
      "no heat after refill",
      "hot tub not heating after refill",
      "weak jets after refill",
      "no jets after refill",
      "pump humming after refill",
      "heater not working after refill",
      "spa worked before i drained it",
      "hot tub worked before draining",
      "problem started after refilling",
      "problem started after draining"
    ]
  },
  {
    "id": "hot-tub-not-heating",
    "phrases": [
      "hot tub not heating",
      "spa not heating",
      "spa heating problems",
      "spa heater not working",
      "hot tub heater not working",
      "why is my hot tub not hot",
      "hot tub wont heat",
      "hot tub won't heat",
      "water wont get warm",
      "water won't get warm",
      "spa only gets lukewarm",
      "hot tub takes forever to heat",
      "heater wont turn on",
      "heater won't turn on",
      "no heat",
      "heating issue",
      "heating problem",
      "spa is cold",
      "heater works with filter removed",
      "heats with filter removed",
      "heater runs then stops",
      "heater clicks but no heat",
      "heater light is on but water is cold",
      "spa heats very slowly",
      "takes all day to heat",
      "not hot enough"
    ]
  },
  {
    "id": "hot-tub-overheating",
    "phrases": [
      "spa overheating",
      "hot tub too hot",
      "temperature too high",
      "heater overheating",
      "high limit problem",
      "hot tub wont stop heating",
      "hot tub won't stop heating",
      "temperature keeps climbing",
      "spa says oh",
      "spa says hl",
      "water hotter than setting",
      "overheat error",
      "high limit tripping"
    ]
  },
  {
    "id": "heater-flow-dry-fire",
    "phrases": [
      "heater dry fire",
      "dry heater",
      "heater shuts off",
      "heater trips high limit",
      "heater flow problem",
      "heater wont stay on",
      "heater won't stay on",
      "heater gets hot but water stays cold",
      "heater stopped after draining spa",
      "no water through heater",
      "dry error",
      "dr error",
      "dry code"
    ]
  },
  {
    "id": "pump-not-running",
    "phrases": [
      "spa pump not working",
      "hot tub pump wont start",
      "hot tub pump won't start",
      "pump dead",
      "motor wont run",
      "motor won't run",
      "circulation pump not running",
      "pump does nothing",
      "pump wont turn on",
      "pump won't turn on",
      "spa pump stopped working",
      "jets wont come on"
    ]
  },
  {
    "id": "pump-humming",
    "phrases": [
      "pump humming",
      "motor buzzing",
      "pump buzzes",
      "pump stuck",
      "motor seized",
      "bad capacitor",
      "pump makes noise but doesnt move water",
      "pump makes noise but doesn't move water",
      "motor sounds like it wants to start",
      "pump hums then trips breaker",
      "pump humming but not running",
      "pump humming but not turning on",
      "pump runs then stops",
      "pump starts then hums",
      "pump clicks and hums",
      "motor gets hot and shuts off"
    ]
  },
  {
    "id": "pump-noisy",
    "phrases": [
      "loud pump",
      "noisy motor",
      "grinding pump",
      "squealing pump",
      "rattling pump",
      "bad bearings",
      "spa pump so loud",
      "pump sounds like rocks",
      "motor screaming",
      "pump suddenly sounds different"
    ]
  },
  {
    "id": "weak-jets-low-flow",
    "phrases": [
      "weak jets",
      "poor jet pressure",
      "low flow",
      "poor circulation",
      "jets barely working",
      "reduced water flow",
      "jets dont have pressure",
      "jets don't have pressure",
      "water barely comes out",
      "spa isnt circulating well",
      "spa isn't circulating well",
      "some jets stronger than others"
    ]
  },
  {
    "id": "flow-error",
    "phrases": [
      "flo",
      "flow",
      "flow error",
      "no circulation",
      "flow switch problem",
      "pressure switch problem",
      "restricted flow",
      "spa says flo",
      "flo keeps appearing",
      "heater wont run because of flow",
      "heater won't run because of flow",
      "pump runs but no water moves",
      "flow error comes and goes"
    ]
  },
  {
    "id": "pump-leaking",
    "phrases": [
      "shaft seal leak",
      "wet end leak",
      "pump seal leaking",
      "water under pump",
      "leaking pump union",
      "pump drips when running",
      "water leaking between motor and pump",
      "wet end leaking",
      "leak only when pump runs",
      "pump only leaks when running",
      "water under motor",
      "leak between wet end and motor",
      "drips from shaft"
    ]
  },
  {
    "id": "hot-tub-losing-water",
    "phrases": [
      "spa water loss",
      "hot tub leak",
      "slow leak",
      "plumbing leak",
      "water level dropping",
      "hot tub lose water overnight",
      "keep having to add water",
      "where is my spa leaking",
      "puddle under hot tub",
      "water disappears when pump runs"
    ]
  },
  {
    "id": "breaker-gfci-tripping",
    "phrases": [
      "breaker trips",
      "gfci trips",
      "electrical short",
      "spa trips breaker",
      "hot tub trips gfci",
      "hot tub keeps shutting breaker off",
      "gfci wont stay reset",
      "gfci won't stay reset",
      "breaker trips when heater starts",
      "breaker trips when pump comes on",
      "breaker trips only when heater comes on",
      "breaker trips when jets start",
      "gfci trips when pump starts",
      "breaker stays on until heater starts",
      "spa runs then trips breaker",
      "hot tub powers up then shuts off"
    ]
  },
  {
    "id": "no-power-dead-spa",
    "phrases": [
      "spa wont turn on",
      "spa won't turn on",
      "dead spa",
      "no display",
      "nothing works",
      "control system has no power",
      "hot tub completely dead",
      "nothing happens when i press buttons",
      "topside blank",
      "spa suddenly shut off",
      "no power to hot tub"
    ]
  },
  {
    "id": "circuit-board-problem",
    "phrases": [
      "bad circuit board",
      "bad pcb",
      "burned board",
      "failed relay",
      "control board failure",
      "spa board problem",
      "circuit board bad",
      "board has burned spot",
      "heater relay burned",
      "component wont turn on",
      "component won't turn on",
      "spa works intermittently"
    ]
  },
  {
    "id": "topside-problem",
    "phrases": [
      "topside dead",
      "keypad not working",
      "spa display bad",
      "buttons not working",
      "control panel failure",
      "display blank",
      "display missing segments",
      "buttons work sometimes",
      "topside frozen",
      "topside control bad",
      "balboa vl display problem",
      "balboa ml display problem",
      "balboa topside says code",
      "keypad says error",
      "buttons beep but nothing happens"
    ]
  },
  {
    "id": "control-pack-problem",
    "phrases": [
      "spa pack problem",
      "control box problem",
      "control system failure",
      "wrong control pack",
      "balboa pack issue",
      "spa pack bad",
      "control box isnt operating equipment",
      "control box isn't operating equipment",
      "what control system do i have",
      "need replacement control pack",
      "balboa bp7 problem",
      "balboa bp100 problem",
      "balboa vs system problem",
      "balboa gs system problem",
      "gecko control problem",
      "hydroquip control problem",
      "spa pack clicking"
    ]
  },
  {
    "id": "temperature-sensor-problem",
    "phrases": [
      "bad temperature sensor",
      "temp sensor error",
      "incorrect temperature",
      "sn error",
      "sna",
      "snb",
      "spa temperature wrong",
      "display says hotter than water",
      "temperature jumps around",
      "heater wont run because sensor error",
      "heater won't run because sensor error"
    ]
  },
  {
    "id": "high-limit-sensor-problem",
    "phrases": [
      "high limit sensor",
      "hl error",
      "high limit trip",
      "overheat sensor",
      "sensor failure",
      "high limit keeps tripping",
      "spa thinks its overheating",
      "spa thinks it's overheating",
      "heater shuts off even though water is cold"
    ]
  },
  {
    "id": "hot-tub-error-code",
    "phrases": [
      "error message",
      "spa code",
      "balboa error",
      "topside error code",
      "diagnostic message",
      "what does this code mean",
      "spa flashing code",
      "balboa display says flo",
      "balboa display says oh",
      "balboa display says dr",
      "balboa display says sn",
      "what is wrong with my hot tub",
      "balboa bp7 error",
      "balboa bp100 error",
      "balboa vs error",
      "balboa gs error",
      "balboa vl error",
      "balboa ml error",
      "gecko error code",
      "hydroquip error"
    ]
  },
  {
    "id": "dry-error",
    "phrases": [
      "dry heater",
      "dr error",
      "dry error",
      "heater has no water",
      "inadequate heater flow",
      "spa says dr",
      "hot tub says dry",
      "heater says dry after refill",
      "spa thinks heater is empty"
    ]
  },
  {
    "id": "filter-clogged",
    "phrases": [
      "dirty filter",
      "clogged cartridge",
      "restricted filter",
      "low flow from filter",
      "old filter",
      "dirty filter cause flo",
      "spa works when filter removed",
      "jets stronger without filter",
      "heater wont run with filter installed",
      "heater won't run with filter installed",
      "works with filter removed",
      "heater works without filter",
      "flo goes away with filter removed",
      "jets stronger with filter out",
      "problem disappears when filter removed"
    ]
  },
  {
    "id": "jets-not-working",
    "phrases": [
      "jet not spinning",
      "jet not flowing",
      "dead jet",
      "missing jet",
      "weak spa jet",
      "one jet doesnt work",
      "one jet doesn't work",
      "some jets work and others dont",
      "some jets work and others don't",
      "jet wont spin",
      "jet won't spin",
      "no water coming from jet",
      "jet popped out"
    ]
  },
  {
    "id": "plumbing-union-leak",
    "phrases": [
      "union leak",
      "fitting leak",
      "o ring leak",
      "o-ring leak",
      "plumbing drip",
      "pvc leak",
      "water leaks around union",
      "heater union dripping",
      "pump connection leaking",
      "spa union leaking"
    ]
  },
  {
    "id": "cloudy-water",
    "phrases": [
      "cloudy spa water",
      "hazy water",
      "milky water",
      "dirty looking water",
      "water wont clear",
      "water won't clear",
      "hot tub cloudy after chemicals",
      "water looks white",
      "cant get spa water clear",
      "can't get spa water clear",
      "cloudy after shocking"
    ]
  },
  {
    "id": "foaming-water",
    "phrases": [
      "spa foam",
      "excessive bubbles",
      "foam buildup",
      "soapy water",
      "hot tub foams when jets turn on",
      "bubbles dont disappear",
      "bubbles don't disappear",
      "spa looks like bubble bath"
    ]
  },
  {
    "id": "algae",
    "phrases": [
      "green water",
      "algae buildup",
      "slippery spa",
      "algae returns quickly",
      "algae keeps coming back",
      "spa turns green quickly",
      "walls feel slippery",
      "sanitizer wont stop algae",
      "sanitizer won't stop algae",
      "algae water",
      "green water algae",
      "green spa water",
      "green hot tub water",
      "hot tub water green",
      "spa water green",
      "water turned green",
      "water is green",
      "why is my hot tub water green",
      "why is my spa water green",
      "green water in hot tub",
      "green water in spa",
      "algae in hot tub water",
      "algae in spa water",
      "green slimy water",
      "green cloudy water"
    ]
  },
  {
    "id": "mold-mildew",
    "phrases": [
      "mold",
      "mildew",
      "black spots",
      "mold under cover",
      "mildew smell",
      "black stuff around spa",
      "remove mold from hot tub",
      "spa smells musty"
    ]
  },
  {
    "id": "scale-calcium",
    "phrases": [
      "scale",
      "calcium deposits",
      "white buildup",
      "hard water deposits",
      "scale on heater",
      "scale on impeller",
      "white crust in spa",
      "scale keeps forming",
      "calcium damaged pump",
      "heater covered in scale"
    ]
  },
  {
    "id": "ph-alkalinity",
    "phrases": [
      "high ph",
      "low ph",
      "alkalinity problem",
      "unstable chemistry",
      "water wont balance",
      "water won't balance",
      "ph keeps changing",
      "alkalinity keeps dropping",
      "chemicals dont stay balanced",
      "chemicals don't stay balanced",
      "ph keeps going high"
    ]
  },
  {
    "id": "filter-clean-replace",
    "phrases": [
      "clean filter",
      "replace filter",
      "dirty cartridge",
      "old cartridge",
      "damaged filter",
      "spa filter bad",
      "how often clean filter",
      "when replace cartridge"
    ]
  },
  {
    "id": "pump-replacement",
    "phrases": [
      "replacement pump",
      "bad pump",
      "replace spa motor",
      "wet end replacement",
      "pump sizing",
      "what pump replaces mine",
      "different horsepower pump",
      "how do i match my pump",
      "what amperage pump do i need"
    ]
  },
  {
    "id": "heater-replacement",
    "phrases": [
      "replacement heater",
      "bad heater",
      "obsolete balboa heater",
      "heater assembly replacement",
      "what heater replaces mine",
      "old balboa heater discontinued",
      "identify my heater",
      "which heater fits my spa"
    ]
  },
  {
    "id": "wet-end-impeller",
    "phrases": [
      "broken impeller",
      "damaged wet end",
      "cracked pump housing",
      "impeller clogged",
      "wet end replacement",
      "motor runs but pump doesnt move water",
      "motor runs but pump doesn't move water",
      "impeller broken",
      "replace motor or wet end",
      "pump housing cracked"
    ]
  },
  {
    "id": "pressure-flow-switch",
    "phrases": [
      "pressure switch bad",
      "flow switch bad",
      "switch wont close",
      "switch won't close",
      "heater flow switch",
      "heater pressure switch",
      "flo stays on even though pump works",
      "difference between pressure switch and flow switch"
    ]
  },
  {
    "id": "balboa-m7",
    "phrases": [
      "m7 sensor error",
      "m7 heater problem",
      "balboa m7 troubleshooting",
      "two sensor heater",
      "m7 flow issue",
      "how does balboa m7 know there is flow",
      "why am i getting m7 errors",
      "which m7 sensor is bad"
    ]
  },
  {
    "id": "circulation-problem",
    "phrases": [
      "poor circulation",
      "circulation problem",
      "no circulation",
      "stagnant water",
      "circulation pump issue",
      "spa not circulating",
      "water barely moves when jets are off",
      "heater says flow error",
      "circulation pump isnt moving water",
      "circulation pump isn't moving water",
      "circulation stops after refill",
      "only circulates with jets on",
      "no circulation in heating mode",
      "circulation pump runs but no flow"
    ]
  },
  {
    "id": "manufacturer-system-aliases",
    "phrases": [
      "balboa",
      "balboa water group",
      "gecko",
      "hydroquip",
      "bp7",
      "bp100",
      "vs",
      "gs",
      "vl",
      "ml",
      "m7",
      "spa pack",
      "control pack",
      "control box",
      "spa controller"
    ]
  },
  {
    "id": "slow-heating",
    "phrases": [
      "hot tub heating slowly",
      "spa heating slowly",
      "takes too long to heat",
      "takes forever to heat",
      "spa wont reach temperature",
      "spa won't reach temperature",
      "hot tub loses heat overnight",
      "heater works but spa stays lukewarm",
      "only gaining a few degrees",
      "slow heat recovery"
    ]
  },
  {
    "id": "temperature-reading-wrong",
    "phrases": [
      "temperature display wrong",
      "spa temperature inaccurate",
      "display says 104 but water is cold",
      "display temperature does not match water",
      "temperature fluctuates",
      "temperature jumps around",
      "wrong water temperature reading",
      "hot tub thermostat wrong",
      "spa says hotter than it is"
    ]
  },
  {
    "id": "pump-starts-then-stops",
    "phrases": [
      "pump starts then stops",
      "pump runs then shuts off",
      "pump turns on then off",
      "pump overheats and stops",
      "motor thermal overload",
      "pump works for a minute then stops",
      "spa pump cycles off",
      "pump gets hot and shuts down"
    ]
  },
  {
    "id": "pump-cavitation",
    "phrases": [
      "pump cavitation",
      "pump sucking air",
      "pump sounds like gravel",
      "pump sounds like rocks",
      "bubbles coming from jets",
      "flow surges",
      "pump rattling with air",
      "air entering pump",
      "pump starving for water",
      "pump noisy low flow"
    ]
  },
  {
    "id": "pump-wont-prime",
    "phrases": [
      "pump wont prime",
      "pump won't prime",
      "spa pump not priming",
      "air in spa pump",
      "air locked pump",
      "pump has air in it",
      "how to prime spa pump",
      "pump lost prime",
      "pump runs dry after refill"
    ]
  },
  {
    "id": "circulation-pump",
    "phrases": [
      "circulation pump not working",
      "circ pump not working",
      "circulation pump dead",
      "therapy jets work but no circulation",
      "no circulation when jets are off",
      "heater wont run circulation pump",
      "heater won't run circulation pump",
      "small circulation pump not running",
      "24 hour circulation pump problem"
    ]
  },
  {
    "id": "one-pump-speed-only",
    "phrases": [
      "low speed works high speed does not",
      "high speed works low speed does not",
      "only one pump speed works",
      "two speed pump only runs low",
      "two speed pump only runs high",
      "pump stuck on low speed",
      "pump wont go to high speed",
      "pump won't go to high speed"
    ]
  },
  {
    "id": "some-jets-not-working",
    "phrases": [
      "only some jets work",
      "one side of spa jets weak",
      "one jet not working",
      "some jets have no flow",
      "individual jet dead",
      "half the jets not working",
      "one bank of jets not working",
      "jet face closed",
      "jet insert blocked"
    ]
  },
  {
    "id": "fuse-keeps-blowing",
    "phrases": [
      "fuse keeps blowing",
      "spa fuse blows",
      "control board fuse blows",
      "transformer fuse blows",
      "fuse blows immediately",
      "fuse blows when pump starts",
      "fuse blows when heater starts",
      "hot tub fuse keeps popping"
    ]
  },
  {
    "id": "transformer-low-voltage",
    "phrases": [
      "spa transformer bad",
      "hot tub transformer problem",
      "low voltage not working",
      "topside has no low voltage",
      "transformer fuse blown",
      "control board has partial power",
      "12 volt spa problem",
      "24 volt spa problem",
      "low voltage equipment dead"
    ]
  },
  {
    "id": "relay-contactor",
    "phrases": [
      "relay clicking",
      "relay stuck",
      "heater relay burned",
      "pump relay burned",
      "contactor clicking",
      "relay wont release",
      "relay won't release",
      "component stays on relay",
      "burned relay on circuit board"
    ]
  },
  {
    "id": "topside-communication",
    "phrases": [
      "topside communication error",
      "control panel communication error",
      "topside not communicating",
      "display strange characters",
      "topside display scrambled",
      "buttons beep but nothing happens",
      "topside lights but wont control spa",
      "topside lights but won't control spa"
    ]
  },
  {
    "id": "priming-mode",
    "phrases": [
      "spa stuck in priming mode",
      "wont exit priming mode",
      "won't exit priming mode",
      "pr stays on",
      "priming cycle never finishes",
      "balboa pr code",
      "pump wont prime in priming mode",
      "spa says pr after refill"
    ]
  },
  {
    "id": "freeze-protection",
    "phrases": [
      "ice message",
      "spa says ice",
      "freeze protection running",
      "hot tub frozen",
      "frozen spa pipes",
      "spa wont start cold weather",
      "spa won't start cold weather",
      "freeze protection mode",
      "hot tub running by itself in cold weather"
    ]
  },
  {
    "id": "water-drops-to-level",
    "phrases": [
      "water drops to same level",
      "spa drains to a certain point",
      "hot tub loses water to jet level",
      "water stops leaking at one level",
      "spa level keeps dropping",
      "hot tub partially drains itself",
      "leak stops when water reaches jets"
    ]
  },
  {
    "id": "leak-only-running",
    "phrases": [
      "leak only when jets are on",
      "leak only when pump runs",
      "spa leaks under pressure",
      "water leaks when pump starts",
      "pressure side spa leak",
      "jet body leaks when running",
      "pump discharge leak"
    ]
  },
  {
    "id": "leak-only-off",
    "phrases": [
      "leak only when spa is off",
      "leak when pump is off",
      "spa leaks overnight",
      "gravity leak hot tub",
      "suction side leak",
      "water drops while spa is off"
    ]
  },
  {
    "id": "filter-dirty-fast",
    "phrases": [
      "filter gets dirty fast",
      "spa filter clogs quickly",
      "filter dirty after a few days",
      "cartridge keeps clogging",
      "filter turns brown quickly",
      "filter gets oily fast",
      "repeated flo dirty filter"
    ]
  },
  {
    "id": "skimmer-poor-suction",
    "phrases": [
      "spa skimmer not working",
      "skimmer weak suction",
      "surface debris not pulled in",
      "skimmer not drawing water",
      "spa skimmer poor flow",
      "weir door stuck",
      "skimmer basket no suction"
    ]
  },
  {
    "id": "bad-water-odor",
    "phrases": [
      "hot tub water smells bad",
      "spa smells bad",
      "musty hot tub water",
      "rotten egg smell hot tub",
      "strong chlorine smell",
      "dirty spa smell",
      "hot tub odor",
      "water smells weird"
    ]
  },
  {
    "id": "slimy-water",
    "phrases": [
      "hot tub water slimy",
      "spa feels slimy",
      "slimy spa walls",
      "slimy water",
      "biofilm hot tub",
      "slick spa surface",
      "green slimy spa",
      "slime in hot tub"
    ]
  },
  {
    "id": "eye-skin-irritation",
    "phrases": [
      "hot tub burns eyes",
      "spa water burns skin",
      "skin irritation after hot tub",
      "itchy skin hot tub",
      "eyes sting in spa",
      "water irritating skin",
      "chlorine burns eyes",
      "bromine irritation hot tub"
    ]
  },
  {
    "id": "sanitizer-wont-hold",
    "phrases": [
      "chlorine wont hold",
      "chlorine won't hold",
      "bromine wont hold",
      "bromine won't hold",
      "sanitizer disappears",
      "sanitizer reads zero",
      "chlorine drops to zero",
      "high sanitizer demand",
      "cant maintain chlorine",
      "can't maintain chlorine"
    ]
  },
  {
    "id": "ph-keeps-rising",
    "phrases": [
      "ph keeps rising",
      "high ph keeps coming back",
      "spa ph always high",
      "hot tub ph climbs",
      "cant keep ph down",
      "can't keep ph down",
      "ph rises after adjustment"
    ]
  },
  {
    "id": "ph-keeps-falling",
    "phrases": [
      "ph keeps falling",
      "low ph keeps coming back",
      "spa ph always low",
      "hot tub ph drops",
      "cant keep ph up",
      "can't keep ph up",
      "ph falls after adjustment"
    ]
  },
  {
    "id": "alkalinity-problem",
    "phrases": [
      "alkalinity too high",
      "alkalinity too low",
      "total alkalinity high",
      "total alkalinity low",
      "cant balance alkalinity",
      "can't balance alkalinity",
      "alkalinity keeps changing"
    ]
  },
  {
    "id": "white-flakes-scale",
    "phrases": [
      "white flakes in hot tub",
      "white flakes in water",
      "calcium flakes",
      "white crust in spa",
      "scale flakes",
      "calcium scale hot tub",
      "white deposits on heater",
      "hard water flakes"
    ]
  },
  {
    "id": "clicking-noise",
    "phrases": [
      "spa clicking noise",
      "hot tub clicking",
      "relay clicking spa",
      "control box clicking",
      "clicking from circuit board",
      "clicking when heater starts",
      "clicking when pump starts"
    ]
  },
  {
    "id": "burning-smell-wiring",
    "phrases": [
      "burning smell hot tub",
      "melted wire spa",
      "burned wiring hot tub",
      "electrical burning smell",
      "hot tub smells electrical",
      "wire insulation melting",
      "burned connector spa",
      "scorched circuit board wire"
    ]
  }
];

  var TARGET_BOOSTS = {
  "slow-heating": [
    "not heating",
    "energy efficiency in spa heaters"
  ],
  "temperature-reading-wrong": [
    "temperature sensors vs",
    "replacing a hot tub temperature"
  ],
  "pump-starts-then-stops": [
    "how to tell if your spa pump is bad",
    "common hot tub electrical problems"
  ],
  "pump-cavitation": [
    "how to tell if your spa pump is bad",
    "understanding spa pumps",
    "after draining"
  ],
  "pump-wont-prime": [
    "after draining",
    "air locks"
  ],
  "circulation-pump": [
    "hot tub troubleshooting guide",
    "hot tub error codes explained"
  ],
  "one-pump-speed-only": [
    "one-speed vs",
    "single-speed vs",
    "how to tell if your spa pump is bad"
  ],
  "some-jets-not-working": [
    "identify your spa jets",
    "hot tub troubleshooting guide"
  ],
  "fuse-keeps-blowing": [
    "common hot tub electrical problems"
  ],
  "transformer-low-voltage": [
    "common hot tub electrical problems",
    "understanding your hot tub circuit board"
  ],
  "relay-contactor": [
    "spa circuit board replacement",
    "common hot tub electrical problems"
  ],
  "topside-communication": [
    "replace a spa topside control panel"
  ],
  "priming-mode": [
    "hot tub error codes explained",
    "after draining"
  ],
  "freeze-protection": [
    "hot tub error codes explained",
    "winterize"
  ],
  "water-drops-to-level": [
    "hot tub leaks",
    "losing water overnight"
  ],
  "leak-only-running": [
    "hot tub leaks",
    "water leaking from under my hot tub pump"
  ],
  "leak-only-off": [
    "hot tub leaks",
    "losing water overnight"
  ],
  "filter-dirty-fast": [
    "golden rules of filter care",
    "clean a pool or hot tub filter cartridge"
  ],
  "skimmer-poor-suction": [
    "skimmers explained",
    "filter cartridge"
  ],
  "bad-water-odor": [
    "water chemistry faq",
    "drain clean and refill"
  ],
  "slimy-water": [
    "mold mildew",
    "algae build up"
  ],
  "eye-skin-irritation": [
    "water chemistry guide",
    "water chemistry faq"
  ],
  "sanitizer-wont-hold": [
    "water chemistry faq",
    "regular hot tub water testing"
  ],
  "ph-keeps-rising": [
    "testing your ph",
    "water chemistry guide"
  ],
  "ph-keeps-falling": [
    "testing your ph",
    "water chemistry guide"
  ],
  "alkalinity-problem": [
    "testing your ph",
    "chemistry alkalinity secrets"
  ],
  "white-flakes-scale": [
    "scale buildup destroys pump impellers",
    "water chemistry guide"
  ],
  "clicking-noise": [
    "spa circuit board replacement",
    "common hot tub electrical problems"
  ],
  "burning-smell-wiring": [
    "hot tub electrical safety",
    "common hot tub electrical problems"
  ]
};

  var STOP_WORDS = {
    "a":1,"an":1,"and":1,"are":1,"can":1,"could":1,"do":1,"does":1,"for":1,
    "how":1,"i":1,"in":1,"is":1,"it":1,"my":1,"of":1,"on":1,"or":1,"the":1,
    "this":1,"to":1,"what":1,"when":1,"where":1,"why":1,"with":1,"would":1,
    "hot":1,"tub":1,"spa":1,"water":1,"problem":1,"problems":1
  };

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/['’]/g, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function tokens(value) {
    var normalized = normalize(value);
    var result = normalized.split(' ').filter(function (t) {
      return t && !STOP_WORDS[t];
    });

    // High-confidence troubleshooting synonym expansion.
    // Green water in a spa/hot tub is commonly how customers describe algae.
    if (
      normalized.indexOf('green water') !== -1 ||
      normalized.indexOf('water green') !== -1 ||
      normalized.indexOf('green spa') !== -1 ||
      normalized.indexOf('green hot tub') !== -1
    ) {
      if (result.indexOf('algae') === -1) result.push('algae');
    }

    if (normalized.indexOf('algae') !== -1) {
      if (result.indexOf('green') === -1) result.push('green');
    }

    return result;
  }

  function phraseScore(query, phrase) {
    var nq = normalize(query);
    var np = normalize(phrase);
    if (!nq || !np) return 0;
    if (nq === np) return 100;
    if (np.indexOf(nq) !== -1 || nq.indexOf(np) !== -1) return 80;

    var q = tokens(nq);
    var p = tokens(np);
    if (!q.length || !p.length) return 0;

    var overlap = q.filter(function (t) { return p.indexOf(t) !== -1; }).length;
    if (!overlap) return 0;

    var coverage = overlap / q.length;
    var precision = overlap / p.length;
    return Math.round((coverage * 55) + (precision * 25));
  }

  function matchedIntents(query) {
    return INTENTS.map(function (intent) {
      var best = 0;
      intent.phrases.forEach(function (phrase) {
        best = Math.max(best, phraseScore(query, phrase));
      });
      return { id: intent.id, score: best };
    }).filter(function (x) {
      return x.score >= 30;
    }).sort(function (a,b) {
      return b.score - a.score;
    });
  }

  function itemText(item) {
    return normalize(
      (item.getAttribute('data-ts') || '') + ' ' +
      (item.textContent || '')
    );
  }

  function scoreItem(item, query, intentMatches) {
    var haystack = itemText(item);
    var score = phraseScore(query, haystack);

    var itemTokens = tokens(haystack);
    var queryTokens = tokens(query);
    var overlap = queryTokens.filter(function (t) {
      return itemTokens.indexOf(t) !== -1;
    }).length;

    score += overlap * 10;

    intentMatches.slice(0, 8).forEach(function (match) {
      var intent = INTENTS.find(function (x) { return x.id === match.id; });
      if (!intent) return;

      var targets = TARGET_BOOSTS[match.id] || [];
      targets.forEach(function (target) {
        if (haystack.indexOf(normalize(target)) !== -1) {
          score += Math.round(match.score * 1.35);
        }
      });

      // Strongly favor the dedicated algae article for green-water/algae searches.
      if (match.id === 'algae') {
        if (haystack.indexOf('why does algae build up so fast') !== -1) {
          score += 220;
        } else if (haystack.indexOf('algae') !== -1 || haystack.indexOf('green') !== -1) {
          score += 90;
        }
      }

      var related = intent.phrases.some(function (phrase) {
        var pt = tokens(phrase);
        if (!pt.length) return false;
        var shared = pt.filter(function (t) {
          return itemTokens.indexOf(t) !== -1;
        }).length;
        // One generic shared word is not enough. Short phrases need an exact meaningful token;
        // longer phrases require at least half of their meaningful tokens.
        return pt.length === 1 ? shared === 1 : shared >= Math.ceil(pt.length * 0.5);
      });

      if (related) score += Math.round(match.score * 0.55);
    });

    return score;
  }

  function init() {
    var root = document.getElementById('bspoTroubleshooting');
    var input = document.getElementById('bspoTsSearch');
    var clear = document.getElementById('bspoTsClear');
    var count = document.getElementById('bspoTsResultCount');
    var empty = document.getElementById('bspoTsEmpty');

    if (!root || !input || !clear || !count || !empty) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('.bspo-ts-filter-item'));
    var sections = Array.prototype.slice.call(root.querySelectorAll('[data-ts-section]'));

    items.forEach(function (item, index) {
      item.setAttribute('data-ts-original-order', String(index));
    });

    function updateArticleGroupHeaders(queryActive) {
      var subheads = Array.prototype.slice.call(
        root.querySelectorAll('.bspo-ts-subhead')
      );

      subheads.forEach(function (subhead) {
        var grid = subhead.nextElementSibling;

        // Only manage subheads that directly label an article-result grid.
        if (!grid || !grid.classList.contains('bspo-ts-article-grid')) return;

        if (!queryActive) {
          subhead.classList.remove('bspo-ts-filter-hidden');
          return;
        }

        var articleItems = Array.prototype.slice.call(
          grid.querySelectorAll('.bspo-ts-filter-item')
        );

        var hasVisible = articleItems.some(function (item) {
          return !item.classList.contains('bspo-ts-filter-hidden');
        });

        subhead.classList.toggle('bspo-ts-filter-hidden', !hasVisible);
      });
    }

    function resetOrder() {
      sections.forEach(function (section) {
        var containers = section.querySelectorAll(
          '.bspo-ts-problem-grid,.bspo-ts-feature-grid,.bspo-ts-link-grid,.bspo-ts-article-grid'
        );
        Array.prototype.forEach.call(containers, function (container) {
          var children = Array.prototype.slice.call(container.children);
          children.sort(function (a,b) {
            return Number(a.getAttribute('data-ts-original-order') || 0) -
                   Number(b.getAttribute('data-ts-original-order') || 0);
          });
          children.forEach(function (child) { container.appendChild(child); });
        });
      });
    }

    function filterPage() {
      var query = input.value || '';
      var nq = normalize(query);

      if (!nq) {
        items.forEach(function (item) {
          item.classList.remove('bspo-ts-filter-hidden');
          item.removeAttribute('data-ts-score');
        });
        sections.forEach(function (section) {
          section.classList.remove('bspo-ts-filter-hidden');
        });
        resetOrder();
        updateArticleGroupHeaders(false);
        count.textContent = 'Showing all troubleshooting resources.';
        empty.classList.remove('is-visible');
        return;
      }

      var intentMatches = matchedIntents(query);
      var strongIntent = intentMatches.length && intentMatches[0].score >= 80 ? intentMatches[0] : null;
      var scored = [];

      items.forEach(function (item) {
        var score = scoreItem(item, query, intentMatches);
        item.setAttribute('data-ts-score', String(score));
        scored.push({ item:item, score:score });
      });

      var visible = 0;
      scored.forEach(function (entry) {
        var threshold = strongIntent ? 50 : 24;
        var show = entry.score >= threshold;
        entry.item.classList.toggle('bspo-ts-filter-hidden', !show);
        if (show) visible++;
      });

      sections.forEach(function (section) {
        var sectionItems = Array.prototype.slice.call(section.querySelectorAll('.bspo-ts-filter-item'));
        var sectionVisible = sectionItems.some(function (item) {
          return !item.classList.contains('bspo-ts-filter-hidden');
        });
        section.classList.toggle('bspo-ts-filter-hidden', !sectionVisible);
      });

      // Hide article-category headers when their corresponding article grid has no matches.
      updateArticleGroupHeaders(true);

      // Rank cards within their existing groups without moving resources between sections.
      sections.forEach(function (section) {
        var containers = section.querySelectorAll(
          '.bspo-ts-problem-grid,.bspo-ts-feature-grid,.bspo-ts-link-grid,.bspo-ts-article-grid'
        );
        Array.prototype.forEach.call(containers, function (container) {
          var children = Array.prototype.slice.call(container.children);
          children.sort(function (a,b) {
            var sa = Number(a.getAttribute('data-ts-score') || 0);
            var sb = Number(b.getAttribute('data-ts-score') || 0);
            if (sb !== sa) return sb - sa;
            return Number(a.getAttribute('data-ts-original-order') || 0) -
                   Number(b.getAttribute('data-ts-original-order') || 0);
          });
          children.forEach(function (child) { container.appendChild(child); });
        });
      });

      count.textContent = visible === 1
        ? '1 troubleshooting resource matched.'
        : visible + ' troubleshooting resources matched.';
      empty.classList.toggle('is-visible', visible === 0);
    }

    input.addEventListener('input', filterPage);
    clear.addEventListener('click', function () {
      input.value = '';
      filterPage();
      input.focus();
    });

    filterPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
